import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-87b3bda8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "all-container"
};
const _hoisted_2 = {
  class: "img-container"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "right-container"
};
const _hoisted_5 = {
  class: "text-container"
};
const _hoisted_6 = {
  class: "train-title"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" （ ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" ） ");

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "类型：", -1));

const _hoisted_10 = {
  for: ""
};
const _hoisted_11 = {
  class: "introduction-container"
};
const _hoisted_12 = {
  class: "abbr-title"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 0
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Dialog = _resolveComponent("Dialog");

  const _component_More = _resolveComponent("More");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $options.coverImg,
    alt: $props.imgAlt
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, [_createTextVNode(_toDisplayString($props.trainTitle) + " ", 1), _withDirectives(_createElementVNode("span", null, [_hoisted_7, _createElementVNode("label", null, _toDisplayString($props.termName), 1), _hoisted_8], 512), [[_vShow, $props.showTerm]])]), $props.classType ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: _normalizeClass($props.showType === true ? 'showType' : 'none')
  }, [_hoisted_9, _createTextVNode(" " + _toDisplayString($props.classType), 1)], 2)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: _normalizeClass($props.showWay === true ? 'showWay' : 'none')
  }, [_createElementVNode("label", null, "教学方式： " + _toDisplayString($props.teachType), 1), _createElementVNode("label", _hoisted_10, "培训地点： " + _toDisplayString($props.trainAddress), 1)], 2), _createElementVNode("p", {
    class: _normalizeClass($props.showClassTime === true ? 'showClassTime' : 'none')
  }, [_createElementVNode("label", null, "考试时间：" + _toDisplayString($props.startTime) + " 至 " + _toDisplayString($props.endTime), 1)], 2), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("p", _hoisted_12, "简介：", 512), [[_vShow, $props.abbr === false ? true : false]]), _createElementVNode("p", {
    innerHTML: $props.trainDescribe,
    class: _normalizeClass($props.abbr === true ? 'showDescribe' : 'showDesc')
  }, null, 10, _hoisted_13), $props.showMore ? (_openBlock(), _createElementBlock("div", _hoisted_14, [$props.trainDescribe.length > 31 ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.showMoreClick && $options.showMoreClick(...args)),
    style: {
      "cursor": "pointer"
    }
  }, ">")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("p", {
    class: _normalizeClass($props.showMaster === true ? 'showMaster' : 'none')
  }, [_createElementVNode("label", null, "主讲人： " + _toDisplayString($props.masterTeacher), 1)], 2)]), _createElementVNode("div", {
    class: _normalizeClass($props.showAction ? 'result-container' : 'notShow')
  }, [_hoisted_15, _createElementVNode("div", {
    class: "action-container",
    style: _normalizeStyle($props.abbr === true ? '' : 'margin-right: -404px;')
  }, [_createElementVNode("p", {
    class: _normalizeClass(["status", $data.actionName === '去付款' ? 'toPayPrice' : 'normal'])
  }, [_createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = $event => $options.refusedClick($data._status)),
    style: _normalizeStyle($data._status === '报名被驳回>' ? 'cursor:pointer' : 'background-color: #ffff;')
  }, _toDisplayString($data._status), 5)], 2), _withDirectives(_createElementVNode("button", {
    class: _normalizeClass(["action", $data.actionName === '去学习' || $data.actionName === '查看报名信息' ? 'auditOrSuccess' : $data.actionName === '去付款' ? 'toPay' : 'refused']),
    onClick: _cache[2] || (_cache[2] = $event => $options.actionClick($props.recruitId, $props.trainingId))
  }, [_createElementVNode("span", null, _toDisplayString($data.actionName), 1)], 2), [[_vShow, $data.actionName === '' ? false : true]])], 4)], 2)]), _hoisted_16]), _createElementVNode("div", {
    class: _normalizeClass($props.showLine === true ? 'line' : 'none')
  }, null, 2), _createVNode(_component_Dialog, {
    ref: "child",
    rejectInfo: $data.rejectInfo
  }, null, 8, ["rejectInfo"]), _createVNode(_component_More, {
    isShow: $data.isShowSeeMoreDialog,
    "onUpdate:isShow": _cache[3] || (_cache[3] = $event => $data.isShowSeeMoreDialog = $event),
    content: $props.trainDescribe
  }, null, 8, ["isShow", "content"])], 64);
}